export const siteMeta = {
  name: 'Greg Cothran',
  domain: 'gregcothran.com',
  canonicalUrl: 'https://gregcothran.com/',
  tagline: 'Ideas to reality, built with mission discipline.',
  shortPositioning:
    'Greg Cothran turns hard ideas into working systems across mission operations, AI, software delivery, and resilient infrastructure.',
  offerLine:
    'Fractional Chief AI Officer (CAIO) and Artificial Intelligence (AI) transformation consulting for organizations that need practical AI systems, governed delivery, and measurable operational value.',
  proofLine: 'People, technology, and operations. Clear thinking. Working results.',
  audienceOrder: [
    'Executive recruiters',
    'Mission and government leaders',
    'Business partners',
    'Builders and technologists'
  ] as const,
  identityRequirements: {
    mountainHero: true,
    colbyConnectedButRestrained: true,
    cognitiveWorksteadSecondary: true
  }
};

export const buyerProblem = {
  title: 'AI is easy to demo. It is harder to make dependable.',
  lead:
    'Greg helps organizations move past pilots, prompts, and disconnected experiments into governed AI capability: clear use cases, executive alignment, operating controls, evaluation, secure implementation, and systems that improve without losing accountability.',
  point:
    'AI can accelerate the build. The harder work is choosing the right problem, connecting it to real operations, governing what the system is allowed to do, and proving that it works.'
};

export const proofPoints = [
  { value: '99.99%', label: 'System uptime', detail: 'Command-and-control systems where uptime, readiness, and judgment matter.' },
  { value: '700+', label: 'Aircraft and assets', detail: 'Integrated and sustained airborne assets for demanding mission environments.' },
  { value: '1,400+', label: 'Team members led', detail: 'Led large teams through standards, tempo, accountability, and trust.' }
];

export const enterpriseProof = [
  { value: '30+', label: 'Years', detail: 'Technology, operations, and mission leadership.' },
  { value: 'TS/SCI', label: 'Clearance', detail: 'Top Secret/Sensitive Compartmented Information context and disciplined judgment.' },
  { value: '$2B+', label: 'Account value', detail: 'Enterprise portfolios supported across complex clients.' },
  { value: '$250M', label: 'Regional portfolio', detail: 'Operational leadership at meaningful business scale.' },
  { value: '12.7%', label: 'Cost reduction', detail: 'Targeted operating improvement with 8% organic growth.' }
];

export const services = [
  {
    title: 'Fractional Chief AI Officer (CAIO)',
    body: 'Executive AI leadership for organizations that need strategy, governance, adoption, investment judgment, and delivery discipline without waiting for a full-time role to mature.'
  },
  {
    title: 'AI Governance',
    body: 'AI governance, authority boundaries, risk controls, review patterns, evaluation evidence, and operating policies that let AI move into real work without losing trust.'
  },
  {
    title: 'Private AI and Automation',
    body: 'Local-first and private AI patterns, workflow automation, data readiness, and knowledge operations designed around security, usefulness, and human approval.'
  },
  {
    title: 'AI Delivery Systems',
    body: 'Software Factory-style delivery: discovery, requirements, build, tests, review, traceability, and continuous improvement for AI-enabled systems.'
  }
];

export const buyerAudiences = [
  'Chief executive officers (CEOs) and boards considering meaningful AI investment',
  'Chief information officer (CIO), chief technology officer (CTO), and operations teams needing execution discipline',
  'Mission and government leaders with trust and control requirements',
  'Investors, founders, and partners building AI-enabled products'
];

export const navigation = [
  { label: 'Services', href: '/work' },
  { label: 'Projects', href: '/projects' },
  { label: 'Thinking', href: '/thinking' },
  { label: 'About', href: '/about' }
];

export const workModes = [
  'Clarify the mission.',
  'Structure the work.',
  'Move fast without losing trust or control.',
  'Keep improving until the system earns trust.'
];

export const voicePrinciples = [
  'Plainspoken under pressure.',
  'Technical depth with operational judgment.',
  'Creative enough to see the next move.',
  'Disciplined enough to make it real.'
];
